import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("emx_user") || "null"); }
    catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("emx_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("emx_user", JSON.stringify(r.data)); })
      .catch(() => {
        localStorage.removeItem("emx_token");
        localStorage.removeItem("emx_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("emx_token", data.token);
    localStorage.setItem("emx_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const signup = useCallback(async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("emx_token", data.token);
    localStorage.setItem("emx_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("emx_token");
    localStorage.removeItem("emx_user");
    setUser(null);
  }, []);

  // Manually set session (used by password reset auto-login and other flows
  // that already hold a valid token+user from the server)
  const setSession = useCallback((token, userObj) => {
    localStorage.setItem("emx_token", token);
    localStorage.setItem("emx_user", JSON.stringify(userObj));
    setUser(userObj);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
